"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.studyResourceSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const initialState = [];
exports.studyResourceSlice = (0, toolkit_1.createSlice)({
    name: "studyResource",
    initialState,
    reducers: {
        upsert(state, action) {
            const foundIndex = state.findIndex(e => e.studyId === action.payload.studyId);
            if (foundIndex === -1) {
                state.push(action.payload);
            }
            else {
                state.splice(foundIndex, 1, action.payload);
            }
        },
    },
});
//# sourceMappingURL=studyResource.js.map